import React from "react";
import { Props } from "../types";

function DocumentIcon(props: Props) {
  return (
    <svg
      viewBox="3 3 18 18"
      fill="none"
      stroke="currentColor"
      className={props.className}
      style={props.style}
    >
      <path
        d="M4.02693 18.329C4.18385 19.277 5.0075 20 6 20H18C19.1046 20 20 19.1046 20 18V14.1901M4.02693 18.329C4.00922 18.222 4 18.1121 4 18V6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V14.1901M4.02693 18.329L7.84762 14.5083C8.52765 13.9133 9.52219 13.8482 10.274 14.3494L10.7832 14.6888C11.5078 15.1719 12.4619 15.1305 13.142 14.5865L15.7901 12.4679C16.4651 11.9279 17.4053 11.8856 18.1228 12.3484C18.2023 12.3997 18.2731 12.4632 18.34 12.5302L20 14.1901M11 9C11 10.1046 10.1046 11 9 11C7.89543 11 7 10.1046 7 9C7 7.89543 7.89543 7 9 7C10.1046 7 11 7.89543 11 9Z"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        strokeWidth={1.2}
      />
    </svg>
  );
}

export { DocumentIcon };
